export default "__VITE_ASSET__DDR$JJTW__"